<template>
  <suspense>
    <template #default>
      <Main/>
    </template>
    <template #fallback>
      <Loading/>
    </template>
  </suspense>
</template>

<script>

import Main from './views/Main.vue';
import Loading from './components/Loading.vue';

export default {
  name: 'App',
  components: {
    Main,
    Loading
  },
  metaInfo: {
    title: 'Инициатива α',
    link: [
      { rel: 'favicon', href: './assets/favicon.ico' }
    ]
  }
}
</script>

<style>

</style>
